import { useEffect, useState } from "react";

const KEY = "pgp_text_scale";
const MIN = 80, MAX = 150, STEP = 10;
const readScale = () => {
  const v = parseInt(localStorage.getItem(KEY), 10);
  return v >= MIN && v <= MAX ? v : 100;
};

export function TextSizeControl() {
  const [scale, setScale] = useState(readScale);
  useEffect(() => {
    document.documentElement.style.fontSize = scale === 100 ? "" : `${scale}%`;
    localStorage.setItem(KEY, String(scale));
  }, [scale]);
  const btn = "h-8 min-w-[2.25rem] px-2 rounded-md text-sm font-semibold text-slate-300 hover:text-slate-100 hover:bg-slate-800/60 disabled:opacity-40 transition-colors";
  return (
    <div className="flex items-center gap-0.5 rounded-lg border border-slate-700/70 px-1 py-0.5" data-testid="text-size-control">
      <button onClick={() => setScale((s) => Math.max(MIN, s - STEP))} disabled={scale <= MIN} data-testid="text-size-decrease" title="Riduci dimensione testo" className={btn}>A−</button>
      <button onClick={() => setScale(100)} data-testid="text-size-value" title="Ripristina 100%" className="h-8 min-w-[3.25rem] px-1 rounded-md text-xs font-mono text-slate-200 hover:bg-slate-800/60">{scale}%</button>
      <button onClick={() => setScale((s) => Math.min(MAX, s + STEP))} disabled={scale >= MAX} data-testid="text-size-increase" title="Aumenta dimensione testo" className={btn}>A+</button>
    </div>
  );
}

export function LiveClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const date = now.toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  const time = now.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  return (
    <div className="flex items-center gap-2 text-sm text-slate-300 whitespace-nowrap" data-testid="live-clock">
      <span className="hidden md:inline capitalize" data-testid="live-clock-date">{date}</span>
      <span className="font-mono font-semibold text-slate-100 tabular-nums" data-testid="live-clock-time">{time}</span>
    </div>
  );
}
